import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { SharedModule } from "@app/modules/shared/shared.module";
import { SpeCodeFormComponent } from "@dashboard/modules/application-params/specode/components/specode-form/specode-form.component";
import { SpeCodeListComponent } from "@dashboard/modules/application-params/specode/components/specode-list/specode-list.component";
import { VatGroupFormComponent } from "@dashboard/modules/application-params/vat-group/components/vat-group-form/vat-group-form.component";
import { VatGroupsListComponent } from "@dashboard/modules/application-params/vat-group/components/vat-groups-list/vat-groups-list.component";
import { ListboxModule } from "primeng/listbox";
import { TaxareaListComponent } from "@dashboard/modules/application-params/taxarea/components/taxarea-list/taxarea-list.component";
import { VatRateListComponent } from "@dashboard/modules/application-params/vat-rate/components/vat-rate-list/vat-rate-list.component";
import { VatRateFormComponent } from "@dashboard/modules/application-params/vat-rate/components/vat-rate-form/vat-rate-form.component";
import { NumberSchemaFormComponent } from "@dashboard/modules/application-params/number-schema/components/number-schema-form/number-schema-form.component";
import { NumberSchemaListComponent } from "@dashboard/modules/application-params/number-schema/components/number-schema-list/number-schema-list.component";

@NgModule({
  imports: [CommonModule, ListboxModule, SharedModule.forRoot()],
  declarations: [
    SpeCodeFormComponent,
    SpeCodeListComponent,
    VatGroupFormComponent,
    VatGroupsListComponent,
    TaxareaListComponent,
    VatRateListComponent,
    VatRateFormComponent,
    NumberSchemaListComponent,
    NumberSchemaFormComponent,
  ],
  exports: [
    SpeCodeFormComponent,
    SpeCodeListComponent,
    VatGroupFormComponent,
    VatGroupsListComponent,
    VatRateListComponent,
    VatRateFormComponent,
    NumberSchemaListComponent,
    NumberSchemaFormComponent,
  ],
})
export class ApplicationParamsModule {}
